//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {

    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";

  }

  /**
   * @return Success
   */
  user( cancelToken?: CancelToken): Promise<GetCurrentUserResponse> {
    let url_ = this.baseUrl + "/api/app/user";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUser(_response);
    });
  }

  protected processUser(response: AxiosResponse): Promise<GetCurrentUserResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = GetCurrentUserResponse.fromJS(resultData200);
      return Promise.resolve<GetCurrentUserResponse>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetCurrentUserResponse>(null as any);
  }

  /**
   * @return Success
   */
  config( cancelToken?: CancelToken): Promise<GetConfigResponse> {
    let url_ = this.baseUrl + "/api/app/config";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processConfig(_response);
    });
  }

  protected processConfig(response: AxiosResponse): Promise<GetConfigResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = GetConfigResponse.fromJS(resultData200);
      return Promise.resolve<GetConfigResponse>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetConfigResponse>(null as any);
  }

  /**
   * @return Success
   */
  info( cancelToken?: CancelToken): Promise<GetApiInfoResponse> {
    let url_ = this.baseUrl + "/api/app/info";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processInfo(_response);
    });
  }

  protected processInfo(response: AxiosResponse): Promise<GetApiInfoResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = GetApiInfoResponse.fromJS(resultData200);
      return Promise.resolve<GetApiInfoResponse>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetApiInfoResponse>(null as any);
  }

  /**
   * @return Success
   */
  clearGc( cancelToken?: CancelToken): Promise<ClearGarbageCollectorResponse> {
    let url_ = this.baseUrl + "/api/app/clear-gc";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processClearGc(_response);
    });
  }

  protected processClearGc(response: AxiosResponse): Promise<ClearGarbageCollectorResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = ClearGarbageCollectorResponse.fromJS(resultData200);
      return Promise.resolve<ClearGarbageCollectorResponse>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ClearGarbageCollectorResponse>(null as any);
  }

  /**
   * Deactivates the locker.
   * @param body (optional)
   * @return Returns response about operation
   */
  deactivateLocker(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<BaseResponse> {
    let url_ = this.baseUrl + "/api/DeactivateLocker";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDeactivateLocker(_response);
    });
  }

  protected processDeactivateLocker(response: AxiosResponse): Promise<BaseResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = BaseResponse.fromJS(resultData200);
      return Promise.resolve<BaseResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BaseResponse>(null as any);
  }

  /**
   * Activates the locker.
   * @param body (optional)
   * @return Returns response about operation
   */
  activateLocker(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<BaseResponse> {
    let url_ = this.baseUrl + "/api/ActivateLocker";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processActivateLocker(_response);
    });
  }

  protected processActivateLocker(response: AxiosResponse): Promise<BaseResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = BaseResponse.fromJS(resultData200);
      return Promise.resolve<BaseResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BaseResponse>(null as any);
  }

  /**
   * Activate the given locker to production state.
   * @param body (optional)
   * @return Returns response about operation
   */
  productionActivateLocker(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<BaseResponse> {
    let url_ = this.baseUrl + "/api/ProductionActivateLocker";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProductionActivateLocker(_response);
    });
  }

  protected processProductionActivateLocker(response: AxiosResponse): Promise<BaseResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = BaseResponse.fromJS(resultData200);
      return Promise.resolve<BaseResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BaseResponse>(null as any);
  }

  /**
   * Deletes locker. (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  deleteLocker(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<BaseResponse> {
    let url_ = this.baseUrl + "/api/DeleteLocker";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDeleteLocker(_response);
    });
  }

  protected processDeleteLocker(response: AxiosResponse): Promise<BaseResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = BaseResponse.fromJS(resultData200);
      return Promise.resolve<BaseResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - strict limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BaseResponse>(null as any);
  }

  /**
   * Open given compartment on given locker for picking up the parcel.
   * @param body (optional)
   * @return Returns response about operation
   */
  openCompartmentToPickup(request_timestamp: Date, body: CompartmentRequest | undefined, cancelToken?: CancelToken): Promise<OpenCompartmentResponse> {
    let url_ = this.baseUrl + "/api/OpenCompartmentToPickup";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "request-timestamp": request_timestamp !== undefined && request_timestamp !== null ? "" + request_timestamp : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processOpenCompartmentToPickup(_response);
    });
  }

  protected processOpenCompartmentToPickup(response: AxiosResponse): Promise<OpenCompartmentResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = OpenCompartmentResponse.fromJS(resultData200);
      return Promise.resolve<OpenCompartmentResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 408) {
      const _responseText = response.data;
      let result408: any = null;
      let resultData408  = _responseText;
      result408 = ProblemDetails.fromJS(resultData408);
      return throwException("Header with timestamp is old or invalid.", status, _responseText, _headers, result408);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - weak limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OpenCompartmentResponse>(null as any);
  }

  /**
   * Open given compartment on given locker.
   * @param body (optional)
   * @return Returns response about operation
   */
  openCompartmentToSend(request_timestamp: Date, body: CompartmentRequest | undefined, cancelToken?: CancelToken): Promise<OpenCompartmentResponse> {
    let url_ = this.baseUrl + "/api/OpenCompartmentToSend";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "request-timestamp": request_timestamp !== undefined && request_timestamp !== null ? "" + request_timestamp : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processOpenCompartmentToSend(_response);
    });
  }

  protected processOpenCompartmentToSend(response: AxiosResponse): Promise<OpenCompartmentResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = OpenCompartmentResponse.fromJS(resultData200);
      return Promise.resolve<OpenCompartmentResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 408) {
      const _responseText = response.data;
      let result408: any = null;
      let resultData408  = _responseText;
      result408 = ProblemDetails.fromJS(resultData408);
      return throwException("Header with timestamp is old or invalid.", status, _responseText, _headers, result408);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - weak limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OpenCompartmentResponse>(null as any);
  }

  /**
   * Open given compartment on given locker.
   * @param body (optional)
   * @return Returns response about operation
   */
  openCompartment(request_timestamp: Date, body: CompartmentRequest | undefined, cancelToken?: CancelToken): Promise<OpenCompartmentResponse> {
    let url_ = this.baseUrl + "/api/OpenCompartment";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "request-timestamp": request_timestamp !== undefined && request_timestamp !== null ? "" + request_timestamp : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processOpenCompartment(_response);
    });
  }

  protected processOpenCompartment(response: AxiosResponse): Promise<OpenCompartmentResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = OpenCompartmentResponse.fromJS(resultData200);
      return Promise.resolve<OpenCompartmentResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 408) {
      const _responseText = response.data;
      let result408: any = null;
      let resultData408  = _responseText;
      result408 = ProblemDetails.fromJS(resultData408);
      return throwException("Header with timestamp is old or invalid.", status, _responseText, _headers, result408);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - weak limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OpenCompartmentResponse>(null as any);
  }

  /**
   * Open given compartment on given locker.
   * @param body (optional)
   * @return Returns response about operation
   */
  openCompartmentAdmin(body: CompartmentWithWorkflowRequest | undefined, cancelToken?: CancelToken): Promise<OpenCompartmentResponse> {
    let url_ = this.baseUrl + "/api/OpenCompartmentAdmin";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processOpenCompartmentAdmin(_response);
    });
  }

  protected processOpenCompartmentAdmin(response: AxiosResponse): Promise<OpenCompartmentResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = OpenCompartmentResponse.fromJS(resultData200);
      return Promise.resolve<OpenCompartmentResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - weak limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OpenCompartmentResponse>(null as any);
  }

  /**
   * Open all compartments on given locker. (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  openAllCompartments(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<SimpleResponse> {
    let url_ = this.baseUrl + "/api/OpenAllCompartments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processOpenAllCompartments(_response);
    });
  }

  protected processOpenAllCompartments(response: AxiosResponse): Promise<SimpleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SimpleResponse.fromJS(resultData200);
      return Promise.resolve<SimpleResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - strict limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SimpleResponse>(null as any);
  }

  /**
   * Returns the compartment status.
   * @param body (optional)
   * @return Returns response about operation
   */
  getCompartmentState(body: CompartmentRequest | undefined, cancelToken?: CancelToken): Promise<CompartmentStatusResponse> {
    let url_ = this.baseUrl + "/api/GetCompartmentState";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetCompartmentState(_response);
    });
  }

  protected processGetCompartmentState(response: AxiosResponse): Promise<CompartmentStatusResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = CompartmentStatusResponse.fromJS(resultData200);
      return Promise.resolve<CompartmentStatusResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<CompartmentStatusResponse>(null as any);
  }

  /**
   * Returns the list of all compartment with their statuses.
   * @param body (optional)
   * @return Returns response about operation
   */
  getAllCompartmentsStates(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<CompartmentStateListResponse> {
    let url_ = this.baseUrl + "/api/GetAllCompartmentsStates";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetAllCompartmentsStates(_response);
    });
  }

  protected processGetAllCompartmentsStates(response: AxiosResponse): Promise<CompartmentStateListResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = CompartmentStateListResponse.fromJS(resultData200);
      return Promise.resolve<CompartmentStateListResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<CompartmentStateListResponse>(null as any);
  }

  /**
   * Returns list of all known lockers. For the logistics app it returns only the production lockers.
   * @return Returns response about operation
   */
  getLockers( cancelToken?: CancelToken): Promise<LockerListDto[]> {
    let url_ = this.baseUrl + "/api/GetLockers";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetLockers(_response);
    });
  }

  protected processGetLockers(response: AxiosResponse): Promise<LockerListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(LockerListDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<LockerListDto[]>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LockerListDto[]>(null as any);
  }

  /**
   * Returns all active TCP sessions. (ADM)
   * @return Returns response about operation
   */
  getLockerSessions( cancelToken?: CancelToken): Promise<LockerSessionStateListResponse> {
    let url_ = this.baseUrl + "/api/GetLockerSessions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetLockerSessions(_response);
    });
  }

  protected processGetLockerSessions(response: AxiosResponse): Promise<LockerSessionStateListResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = LockerSessionStateListResponse.fromJS(resultData200);
      return Promise.resolve<LockerSessionStateListResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LockerSessionStateListResponse>(null as any);
  }

  /**
   * Kill selected TCP session. (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  killLockerSession(body: SessionRequest | undefined, cancelToken?: CancelToken): Promise<BaseResponse> {
    let url_ = this.baseUrl + "/api/KillLockerSession";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processKillLockerSession(_response);
    });
  }

  protected processKillLockerSession(response: AxiosResponse): Promise<BaseResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = BaseResponse.fromJS(resultData200);
      return Promise.resolve<BaseResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BaseResponse>(null as any);
  }

  /**
   * Returns all active TCP sessions. (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  isLockerConnected(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<BaseResponse> {
    let url_ = this.baseUrl + "/api/IsLockerConnected";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIsLockerConnected(_response);
    });
  }

  protected processIsLockerConnected(response: AxiosResponse): Promise<BaseResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = BaseResponse.fromJS(resultData200);
      return Promise.resolve<BaseResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BaseResponse>(null as any);
  }

  /**
   * Kill all locker TCP session. (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  killAllLockerSessions(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<BaseResponse> {
    let url_ = this.baseUrl + "/api/KillAllLockerSessions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processKillAllLockerSessions(_response);
    });
  }

  protected processKillAllLockerSessions(response: AxiosResponse): Promise<BaseResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = BaseResponse.fromJS(resultData200);
      return Promise.resolve<BaseResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BaseResponse>(null as any);
  }

  /**
   * Sets the temperature limits controlling the fans (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  setFanTemperatureLimits(body: FanTemperatureLimitsRequest | undefined, cancelToken?: CancelToken): Promise<SimpleResponse> {
    let url_ = this.baseUrl + "/api/SetFanTemperatureLimits";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processSetFanTemperatureLimits(_response);
    });
  }

  protected processSetFanTemperatureLimits(response: AxiosResponse): Promise<SimpleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SimpleResponse.fromJS(resultData200);
      return Promise.resolve<SimpleResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SimpleResponse>(null as any);
  }

  /**
   * Queries the temperature limits controlling the fans (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  getFanTemperatureLimits(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<FanTemperatureLimitsResponse> {
    let url_ = this.baseUrl + "/api/GetFanTemperatureLimits";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetFanTemperatureLimits(_response);
    });
  }

  protected processGetFanTemperatureLimits(response: AxiosResponse): Promise<FanTemperatureLimitsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = FanTemperatureLimitsResponse.fromJS(resultData200);
      return Promise.resolve<FanTemperatureLimitsResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FanTemperatureLimitsResponse>(null as any);
  }

  /**
   * Queries the fans statuses (manual/automatic, on/off) (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  getFanStatuses(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<FanStatusesResponse> {
    let url_ = this.baseUrl + "/api/GetFanStatuses";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetFanStatuses(_response);
    });
  }

  protected processGetFanStatuses(response: AxiosResponse): Promise<FanStatusesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = FanStatusesResponse.fromJS(resultData200);
      return Promise.resolve<FanStatusesResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FanStatusesResponse>(null as any);
  }

  /**
   * Queries the automatic power off and power on (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  getAutomaticPowerOffOn(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<AutomaticPowerOffOnResponse> {
    let url_ = this.baseUrl + "/api/GetAutomaticPowerOffOn";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetAutomaticPowerOffOn(_response);
    });
  }

  protected processGetAutomaticPowerOffOn(response: AxiosResponse): Promise<AutomaticPowerOffOnResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = AutomaticPowerOffOnResponse.fromJS(resultData200);
      return Promise.resolve<AutomaticPowerOffOnResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<AutomaticPowerOffOnResponse>(null as any);
  }

  /**
   * Sets the automatic power off and power on (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  setAutomaticPowerOffOn(body: AutomaticPowerOffOnRequest | undefined, cancelToken?: CancelToken): Promise<SimpleResponse> {
    let url_ = this.baseUrl + "/api/SetAutomaticPowerOffOn";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processSetAutomaticPowerOffOn(_response);
    });
  }

  protected processSetAutomaticPowerOffOn(response: AxiosResponse): Promise<SimpleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SimpleResponse.fromJS(resultData200);
      return Promise.resolve<SimpleResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - strict limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SimpleResponse>(null as any);
  }

  /**
   * Instructs the locker to turn off and on again in two minutes (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  restartLocker(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<AutomaticPowerOffOnResponse> {
    let url_ = this.baseUrl + "/api/RestartLocker";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRestartLocker(_response);
    });
  }

  protected processRestartLocker(response: AxiosResponse): Promise<AutomaticPowerOffOnResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = AutomaticPowerOffOnResponse.fromJS(resultData200);
      return Promise.resolve<AutomaticPowerOffOnResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - strict limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<AutomaticPowerOffOnResponse>(null as any);
  }

  /**
   * Gets the heartbeat, retry interval and autorestart interval of the locker (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  getAutorestartInterval(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<AutorestartIntervalResponse> {
    let url_ = this.baseUrl + "/api/GetAutorestartInterval";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetAutorestartInterval(_response);
    });
  }

  protected processGetAutorestartInterval(response: AxiosResponse): Promise<AutorestartIntervalResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = AutorestartIntervalResponse.fromJS(resultData200);
      return Promise.resolve<AutorestartIntervalResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<AutorestartIntervalResponse>(null as any);
  }

  /**
   * Sets the wireless communication parameters (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  setAutorestartInterval(body: AutorestartIntervalRequest | undefined, cancelToken?: CancelToken): Promise<AutomaticPowerOffOnResponse> {
    let url_ = this.baseUrl + "/api/SetAutorestartInterval";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processSetAutorestartInterval(_response);
    });
  }

  protected processSetAutorestartInterval(response: AxiosResponse): Promise<AutomaticPowerOffOnResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = AutomaticPowerOffOnResponse.fromJS(resultData200);
      return Promise.resolve<AutomaticPowerOffOnResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - strict limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<AutomaticPowerOffOnResponse>(null as any);
  }

  /**
   * Queries the sleep mode parameters (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  getSleepModeParameters(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<SleepModeParametersResponse> {
    let url_ = this.baseUrl + "/api/GetSleepModeParameters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetSleepModeParameters(_response);
    });
  }

  protected processGetSleepModeParameters(response: AxiosResponse): Promise<SleepModeParametersResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SleepModeParametersResponse.fromJS(resultData200);
      return Promise.resolve<SleepModeParametersResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SleepModeParametersResponse>(null as any);
  }

  /**
   * Sets the sleep mode parameters (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  setSleepModeParameters(body: SleepModeParametersRequest | undefined, cancelToken?: CancelToken): Promise<SimpleResponse> {
    let url_ = this.baseUrl + "/api/SetSleepModeParameters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processSetSleepModeParameters(_response);
    });
  }

  protected processSetSleepModeParameters(response: AxiosResponse): Promise<SimpleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SimpleResponse.fromJS(resultData200);
      return Promise.resolve<SimpleResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SimpleResponse>(null as any);
  }

  /**
   * Queries the wireless communication parameters (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  getWirelessParameters(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<WirelessParametersResponse> {
    let url_ = this.baseUrl + "/api/GetWirelessParameters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetWirelessParameters(_response);
    });
  }

  protected processGetWirelessParameters(response: AxiosResponse): Promise<WirelessParametersResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = WirelessParametersResponse.fromJS(resultData200);
      return Promise.resolve<WirelessParametersResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<WirelessParametersResponse>(null as any);
  }

  /**
   * Sets the wireless communication parameters (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  setWirelessParameters(body: WirelessParametersRequest | undefined, cancelToken?: CancelToken): Promise<SimpleResponse> {
    let url_ = this.baseUrl + "/api/SetWirelessParameters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processSetWirelessParameters(_response);
    });
  }

  protected processSetWirelessParameters(response: AxiosResponse): Promise<SimpleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SimpleResponse.fromJS(resultData200);
      return Promise.resolve<SimpleResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - strict limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SimpleResponse>(null as any);
  }

  /**
   * Queries the wireless service provider parameters (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  getProviderParameters(body: GetProviderParametersRequest | undefined, cancelToken?: CancelToken): Promise<GetProviderParametersResponse> {
    let url_ = this.baseUrl + "/api/GetProviderParameters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetProviderParameters(_response);
    });
  }

  protected processGetProviderParameters(response: AxiosResponse): Promise<GetProviderParametersResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = GetProviderParametersResponse.fromJS(resultData200);
      return Promise.resolve<GetProviderParametersResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetProviderParametersResponse>(null as any);
  }

  /**
   * Sets the parameters related to the wireless service provider (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  setProviderParameters(body: SetProviderParametersRequest | undefined, cancelToken?: CancelToken): Promise<SimpleResponse> {
    let url_ = this.baseUrl + "/api/SetProviderParameters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processSetProviderParameters(_response);
    });
  }

  protected processSetProviderParameters(response: AxiosResponse): Promise<SimpleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SimpleResponse.fromJS(resultData200);
      return Promise.resolve<SimpleResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - strict limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SimpleResponse>(null as any);
  }

  /**
   * Queries the lockers IMEI (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  getImei(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<ImeiResponse> {
    let url_ = this.baseUrl + "/api/GetImei";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetImei(_response);
    });
  }

  protected processGetImei(response: AxiosResponse): Promise<ImeiResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = ImeiResponse.fromJS(resultData200);
      return Promise.resolve<ImeiResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ImeiResponse>(null as any);
  }

  /**
   * Queries the lockers ICCID (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  getIccid(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<IccidResponse> {
    let url_ = this.baseUrl + "/api/GetIccid";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetIccid(_response);
    });
  }

  protected processGetIccid(response: AxiosResponse): Promise<IccidResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = IccidResponse.fromJS(resultData200);
      return Promise.resolve<IccidResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<IccidResponse>(null as any);
  }

  /**
   * Requests download of the log from a locker (ADM)
   * @param body (optional) specifies the requested date
   * @return Returns response about operation
   */
  startLogDownload(body: ReadLogRequest | undefined, cancelToken?: CancelToken): Promise<ReadLogResponse> {
    let url_ = this.baseUrl + "/api/StartLogDownload";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processStartLogDownload(_response);
    });
  }

  protected processStartLogDownload(response: AxiosResponse): Promise<ReadLogResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = ReadLogResponse.fromJS(resultData200);
      return Promise.resolve<ReadLogResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ReadLogResponse>(null as any);
  }

  /**
   * Asks the locker for the date of the oldest log file it stores (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  getOldestLogDate(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<GetOldestLogDateResponse> {
    let url_ = this.baseUrl + "/api/GetOldestLogDate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetOldestLogDate(_response);
    });
  }

  protected processGetOldestLogDate(response: AxiosResponse): Promise<GetOldestLogDateResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = GetOldestLogDateResponse.fromJS(resultData200);
      return Promise.resolve<GetOldestLogDateResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetOldestLogDateResponse>(null as any);
  }

  /**
   * Gets actual report from locker.
   * @param body (optional)
   * @return Returns response about operation
   */
  report(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<LockerDetailDto> {
    let url_ = this.baseUrl + "/api/Report";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processReport(_response);
    });
  }

  protected processReport(response: AxiosResponse): Promise<LockerDetailDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = LockerDetailDto.fromJS(resultData200);
      return Promise.resolve<LockerDetailDto>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LockerDetailDto>(null as any);
  }

  /**
   * Sets text to LCD. After specified duration the EnterCode is displayed.
   * @param body (optional)
   * @return Returns response about operation
   */
  setLcdText(body: SetLcdTextRequest | undefined, cancelToken?: CancelToken): Promise<SimpleResponse> {
    let url_ = this.baseUrl + "/api/SetLcdText";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processSetLcdText(_response);
    });
  }

  protected processSetLcdText(response: AxiosResponse): Promise<SimpleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SimpleResponse.fromJS(resultData200);
      return Promise.resolve<SimpleResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SimpleResponse>(null as any);
  }

  /**
   * Resets locker. (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  resetLocker(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<SimpleResponse> {
    let url_ = this.baseUrl + "/api/ResetLocker";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processResetLocker(_response);
    });
  }

  protected processResetLocker(response: AxiosResponse): Promise<SimpleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SimpleResponse.fromJS(resultData200);
      return Promise.resolve<SimpleResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SimpleResponse>(null as any);
  }

  /**
   * Update locker firmware. (ADM)
   * @param lockerId lockerId
   * @param firmware (optional)
   * @return Returns response about operation
   */
  firmwareUpdate(lockerId: string, firmware: FileParameter | undefined, cancelToken?: CancelToken): Promise<SimpleResponse> {
    let url_ = this.baseUrl + "/api/FirmwareUpdate?";
    if (lockerId === undefined || lockerId === null)
      throw new Error("The parameter 'lockerId' must be defined and cannot be null.");
    else
      url_ += "lockerId=" + encodeURIComponent("" + lockerId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (firmware === null || firmware === undefined)
      throw new Error("The parameter 'firmware' cannot be null.");
    else
      content_.append("firmware", firmware.data, firmware.fileName ? firmware.fileName : "firmware");

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processFirmwareUpdate(_response);
    });
  }

  protected processFirmwareUpdate(response: AxiosResponse): Promise<SimpleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SimpleResponse.fromJS(resultData200);
      return Promise.resolve<SimpleResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SimpleResponse>(null as any);
  }

  /**
   * Get the status of firmware update. (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  getFirmwareUpdateStatus(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<FirmwareUpdateResponse> {
    let url_ = this.baseUrl + "/api/GetFirmwareUpdateStatus";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetFirmwareUpdateStatus(_response);
    });
  }

  protected processGetFirmwareUpdateStatus(response: AxiosResponse): Promise<FirmwareUpdateResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = FirmwareUpdateResponse.fromJS(resultData200);
      return Promise.resolve<FirmwareUpdateResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FirmwareUpdateResponse>(null as any);
  }

  /**
   * Creates new RSA key for locker (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  generateNewRsaKey(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<RsaKeyResponse> {
    let url_ = this.baseUrl + "/api/GenerateNewRsaKey";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGenerateNewRsaKey(_response);
    });
  }

  protected processGenerateNewRsaKey(response: AxiosResponse): Promise<RsaKeyResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = RsaKeyResponse.fromJS(resultData200);
      return Promise.resolve<RsaKeyResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - strict limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RsaKeyResponse>(null as any);
  }

  /**
   * Switches current and previous RSA keys (ADM)
   * @param body (optional)
   * @return Returns response about operation
   */
  switchRsaKeys(body: LockerRequest | undefined, cancelToken?: CancelToken): Promise<RsaKeyResponse> {
    let url_ = this.baseUrl + "/api/SwitchRsaKeys";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processSwitchRsaKeys(_response);
    });
  }

  protected processSwitchRsaKeys(response: AxiosResponse): Promise<RsaKeyResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = RsaKeyResponse.fromJS(resultData200);
      return Promise.resolve<RsaKeyResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429  = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("Too many calls today - strict limit.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RsaKeyResponse>(null as any);
  }

  /**
   * Switches current and previous RSA keys (ADM)
   * @return Returns response about operation
   */
  resetLockerCounters( cancelToken?: CancelToken): Promise<SimpleResponse> {
    let url_ = this.baseUrl + "/api/ResetLockerCounters";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processResetLockerCounters(_response);
    });
  }

  protected processResetLockerCounters(response: AxiosResponse): Promise<SimpleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SimpleResponse.fromJS(resultData200);
      return Promise.resolve<SimpleResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SimpleResponse>(null as any);
  }

  /**
   * Sets new offline PINs for given locker.
   Before setting new offline PINs, all previous PINs are deleted. All pins should be exactly 6 digits.
   * @param lockerId The locker ID
   * @param body (optional)
   * @return Returns response about operation
   */
  offlinePinPUT(lockerId: string, body: OfflinePinSetting[] | undefined, cancelToken?: CancelToken): Promise<SetOfflinePinResponse> {
    let url_ = this.baseUrl + "/api/offline-pin/{LockerId}";
    if (lockerId === undefined || lockerId === null)
      throw new Error("The parameter 'lockerId' must be defined.");
    url_ = url_.replace("{LockerId}", encodeURIComponent("" + lockerId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processOfflinePinPUT(_response);
    });
  }

  protected processOfflinePinPUT(response: AxiosResponse): Promise<SetOfflinePinResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SetOfflinePinResponse.fromJS(resultData200);
      return Promise.resolve<SetOfflinePinResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SetOfflinePinResponse>(null as any);
  }

  /**
   * Get information about used offline PINs.
   * @param lockerId The locker ID
   * @return Returns response about operation
   */
  offlinePinGET(lockerId: string, cancelToken?: CancelToken): Promise<GetUsedOfflinePinsResponse> {
    let url_ = this.baseUrl + "/api/offline-pin/{LockerId}";
    if (lockerId === undefined || lockerId === null)
      throw new Error("The parameter 'lockerId' must be defined.");
    url_ = url_.replace("{LockerId}", encodeURIComponent("" + lockerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processOfflinePinGET(_response);
    });
  }

  protected processOfflinePinGET(response: AxiosResponse): Promise<GetUsedOfflinePinsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = GetUsedOfflinePinsResponse.fromJS(resultData200);
      return Promise.resolve<GetUsedOfflinePinsResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetUsedOfflinePinsResponse>(null as any);
  }

  /**
   * Adds new offline PINs for given locker.
   Before setting new offline PINs, all previous PINs are deleted. All pins should be exactly 6 digits.
   * @param lockerId The locker ID
   * @param body (optional)
   * @return Returns response about operation
   */
  offlinePinAppend(lockerId: string, body: OfflinePinSetting[] | undefined, cancelToken?: CancelToken): Promise<SetOfflinePinResponse> {
    let url_ = this.baseUrl + "/api/offline-pin-append/{LockerId}";
    if (lockerId === undefined || lockerId === null)
      throw new Error("The parameter 'lockerId' must be defined.");
    url_ = url_.replace("{LockerId}", encodeURIComponent("" + lockerId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processOfflinePinAppend(_response);
    });
  }

  protected processOfflinePinAppend(response: AxiosResponse): Promise<SetOfflinePinResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SetOfflinePinResponse.fromJS(resultData200);
      return Promise.resolve<SetOfflinePinResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SetOfflinePinResponse>(null as any);
  }

  /**
   * Get information about used offline PIN of given compartment.
   * @param compartmentNumber The compartment number
   * @param lockerId The locker ID
   * @return Returns response about operation
   */
  offlinePinGET2(compartmentNumber: number, lockerId: string, cancelToken?: CancelToken): Promise<GetUsedOfflinePinResponse> {
    let url_ = this.baseUrl + "/api/offline-pin/{LockerId}/{CompartmentNumber}";
    if (compartmentNumber === undefined || compartmentNumber === null)
      throw new Error("The parameter 'compartmentNumber' must be defined.");
    url_ = url_.replace("{CompartmentNumber}", encodeURIComponent("" + compartmentNumber));
    if (lockerId === undefined || lockerId === null)
      throw new Error("The parameter 'lockerId' must be defined.");
    url_ = url_.replace("{LockerId}", encodeURIComponent("" + lockerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processOfflinePinGET2(_response);
    });
  }

  protected processOfflinePinGET2(response: AxiosResponse): Promise<GetUsedOfflinePinResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = GetUsedOfflinePinResponse.fromJS(resultData200);
      return Promise.resolve<GetUsedOfflinePinResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetUsedOfflinePinResponse>(null as any);
  }

  /**
   * Get information about used offline PINs.
   * @param count Number of beeps (1 to 10)
   * @param lockerId The locker ID
   * @return Returns response about operation
   */
  beep(count: number, lockerId: string, cancelToken?: CancelToken): Promise<SimpleResponse> {
    let url_ = this.baseUrl + "/api/beep/{LockerId}/{Count}";
    if (count === undefined || count === null)
      throw new Error("The parameter 'count' must be defined.");
    url_ = url_.replace("{Count}", encodeURIComponent("" + count));
    if (lockerId === undefined || lockerId === null)
      throw new Error("The parameter 'lockerId' must be defined.");
    url_ = url_.replace("{LockerId}", encodeURIComponent("" + lockerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "application/json"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processBeep(_response);
    });
  }

  protected processBeep(response: AxiosResponse): Promise<SimpleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200  = _responseText;
      result200 = SimpleResponse.fromJS(resultData200);
      return Promise.resolve<SimpleResponse>(result200);

    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401  = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("No API Key provided", status, _responseText, _headers, result401);

    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403  = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException("Wrong API Key provided", status, _responseText, _headers, result403);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SimpleResponse>(null as any);
  }
}

export class AutomaticPowerOffOnRequest implements IAutomaticPowerOffOnRequest {
  /** The locker ID */
  lockerId!: string;
  /** Power the locker off after this many hours */
  powerOff_Hour!: number;
  /** ... and minutes */
  powerOff_Minute!: number;
  /** Power the locker on again after this many hours */
  powerOn_Hour!: number;
  /** ... and minutes */
  powerOn_Minute?: number;

  constructor(data?: IAutomaticPowerOffOnRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
      this.powerOff_Hour = _data["powerOff_Hour"];
      this.powerOff_Minute = _data["powerOff_Minute"];
      this.powerOn_Hour = _data["powerOn_Hour"];
      this.powerOn_Minute = _data["powerOn_Minute"];
    }
  }

  static fromJS(data: any): AutomaticPowerOffOnRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AutomaticPowerOffOnRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    data["powerOff_Hour"] = this.powerOff_Hour;
    data["powerOff_Minute"] = this.powerOff_Minute;
    data["powerOn_Hour"] = this.powerOn_Hour;
    data["powerOn_Minute"] = this.powerOn_Minute;
    return data;
  }
}

export interface IAutomaticPowerOffOnRequest {
  /** The locker ID */
  lockerId: string;
  /** Power the locker off after this many hours */
  powerOff_Hour: number;
  /** ... and minutes */
  powerOff_Minute: number;
  /** Power the locker on again after this many hours */
  powerOn_Hour: number;
  /** ... and minutes */
  powerOn_Minute?: number;
}

export class AutomaticPowerOffOnResponse implements IAutomaticPowerOffOnResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** Power the locker off AT THIS HOUR (in UTC) */
  powerOff_Hour?: number | undefined;
  /** and minute */
  powerOff_Minute?: number | undefined;
  /** Power the locker on again AT THIS HOUR (in UTC) */
  powerOn_Hour?: number | undefined;
  /** and minutes */
  powerOn_Minute?: number | undefined;

  constructor(data?: IAutomaticPowerOffOnResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.powerOff_Hour = _data["powerOff_Hour"];
      this.powerOff_Minute = _data["powerOff_Minute"];
      this.powerOn_Hour = _data["powerOn_Hour"];
      this.powerOn_Minute = _data["powerOn_Minute"];
    }
  }

  static fromJS(data: any): AutomaticPowerOffOnResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AutomaticPowerOffOnResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["powerOff_Hour"] = this.powerOff_Hour;
    data["powerOff_Minute"] = this.powerOff_Minute;
    data["powerOn_Hour"] = this.powerOn_Hour;
    data["powerOn_Minute"] = this.powerOn_Minute;
    return data;
  }
}

export interface IAutomaticPowerOffOnResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** Power the locker off AT THIS HOUR (in UTC) */
  powerOff_Hour?: number | undefined;
  /** and minute */
  powerOff_Minute?: number | undefined;
  /** Power the locker on again AT THIS HOUR (in UTC) */
  powerOn_Hour?: number | undefined;
  /** and minutes */
  powerOn_Minute?: number | undefined;
}

export class AutorestartIntervalRequest implements IAutorestartIntervalRequest {
  /** The locker ID */
  lockerId!: string;
  /** The locker will restart this many minutes after the last received wireless pulse.
   Leave empty or set to zero to turn the feature off. */
  autorestartInterval?: number | undefined;
  /** The heart beat / wireless pulse interval in minutes */
  heartbeatInterval?: number;
  /** The wireless retry interval in minutes (for attempts to reconnect after losing connection) */
  retryInterval?: number;

  constructor(data?: IAutorestartIntervalRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
      this.autorestartInterval = _data["autorestartInterval"];
      this.heartbeatInterval = _data["heartbeatInterval"];
      this.retryInterval = _data["retryInterval"];
    }
  }

  static fromJS(data: any): AutorestartIntervalRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AutorestartIntervalRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    data["autorestartInterval"] = this.autorestartInterval;
    data["heartbeatInterval"] = this.heartbeatInterval;
    data["retryInterval"] = this.retryInterval;
    return data;
  }
}

export interface IAutorestartIntervalRequest {
  /** The locker ID */
  lockerId: string;
  /** The locker will restart this many minutes after the last received wireless pulse.
   Leave empty or set to zero to turn the feature off. */
  autorestartInterval?: number | undefined;
  /** The heart beat / wireless pulse interval in minutes */
  heartbeatInterval?: number;
  /** The wireless retry interval in minutes (for attempts to reconnect after losing connection) */
  retryInterval?: number;
}

export class AutorestartIntervalResponse implements IAutorestartIntervalResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** The locker will restart this many minutes after the last received wireless pulse
   Leave empty or set to zero to turn the feature off. */
  autorestartInterval?: number | undefined;
  /** The heart beat / wireless pulse interval in minutes */
  heartbeatInterval?: number;
  /** The wireless retry interval in minutes (for attempts to reconnect after losing connection) */
  retryInterval?: number;

  constructor(data?: IAutorestartIntervalResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.autorestartInterval = _data["autorestartInterval"];
      this.heartbeatInterval = _data["heartbeatInterval"];
      this.retryInterval = _data["retryInterval"];
    }
  }

  static fromJS(data: any): AutorestartIntervalResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AutorestartIntervalResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["autorestartInterval"] = this.autorestartInterval;
    data["heartbeatInterval"] = this.heartbeatInterval;
    data["retryInterval"] = this.retryInterval;
    return data;
  }
}

export interface IAutorestartIntervalResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** The locker will restart this many minutes after the last received wireless pulse
   Leave empty or set to zero to turn the feature off. */
  autorestartInterval?: number | undefined;
  /** The heart beat / wireless pulse interval in minutes */
  heartbeatInterval?: number;
  /** The wireless retry interval in minutes (for attempts to reconnect after losing connection) */
  retryInterval?: number;
}

export class BaseResponse implements IBaseResponse {
  result?: Result;

  constructor(data?: IBaseResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
    }
  }

  static fromJS(data: any): BaseResponse {
    data = typeof data === 'object' ? data : {};
    let result = new BaseResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    return data;
  }
}

export interface IBaseResponse {
  result?: Result;
}

export class ClearGarbageCollectorResponse implements IClearGarbageCollectorResponse {
  api?: ModuleMemoryInfo;
  server?: ModuleMemoryInfo;

  constructor(data?: IClearGarbageCollectorResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.api = _data["api"] ? ModuleMemoryInfo.fromJS(_data["api"]) : <any>undefined;
      this.server = _data["server"] ? ModuleMemoryInfo.fromJS(_data["server"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ClearGarbageCollectorResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClearGarbageCollectorResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["api"] = this.api ? this.api.toJSON() : <any>undefined;
    data["server"] = this.server ? this.server.toJSON() : <any>undefined;
    return data;
  }
}

export interface IClearGarbageCollectorResponse {
  api?: ModuleMemoryInfo;
  server?: ModuleMemoryInfo;
}

/** <p>Members:</p><ul></ul> */
export enum CommunicationChannelType {
  Direct = "Direct",
  Bluetooth = "Bluetooth",
}

export class Compartment implements ICompartment {
  /** Compartment number */
  compartmentNumber?: number;
  state?: DoorState;

  constructor(data?: ICompartment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.compartmentNumber = _data["compartmentNumber"];
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): Compartment {
    data = typeof data === 'object' ? data : {};
    let result = new Compartment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["compartmentNumber"] = this.compartmentNumber;
    data["state"] = this.state;
    return data;
  }
}

export interface ICompartment {
  /** Compartment number */
  compartmentNumber?: number;
  state?: DoorState;
}

export class CompartmentDto implements ICompartmentDto {
  compartmentNumber?: number;
  state?: DoorState;
  warning?: CompartmentWarningState;
  isLongOpen?: boolean;
  lastOpenCommand?: Date | undefined;
  lastStateChangeDate?: Date | undefined;
  lastOpenErrorDate?: Date | undefined;
  openErrorCount?: number;

  constructor(data?: ICompartmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.compartmentNumber = _data["compartmentNumber"];
      this.state = _data["state"];
      this.warning = _data["warning"];
      this.isLongOpen = _data["isLongOpen"];
      this.lastOpenCommand = _data["lastOpenCommand"] ? new Date(_data["lastOpenCommand"].toString()) : <any>undefined;
      this.lastStateChangeDate = _data["lastStateChangeDate"] ? new Date(_data["lastStateChangeDate"].toString()) : <any>undefined;
      this.lastOpenErrorDate = _data["lastOpenErrorDate"] ? new Date(_data["lastOpenErrorDate"].toString()) : <any>undefined;
      this.openErrorCount = _data["openErrorCount"];
    }
  }

  static fromJS(data: any): CompartmentDto {
    data = typeof data === 'object' ? data : {};
    let result = new CompartmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["compartmentNumber"] = this.compartmentNumber;
    data["state"] = this.state;
    data["warning"] = this.warning;
    data["isLongOpen"] = this.isLongOpen;
    data["lastOpenCommand"] = this.lastOpenCommand ? this.lastOpenCommand.toISOString() : <any>undefined;
    data["lastStateChangeDate"] = this.lastStateChangeDate ? this.lastStateChangeDate.toISOString() : <any>undefined;
    data["lastOpenErrorDate"] = this.lastOpenErrorDate ? this.lastOpenErrorDate.toISOString() : <any>undefined;
    data["openErrorCount"] = this.openErrorCount;
    return data;
  }
}

export interface ICompartmentDto {
  compartmentNumber?: number;
  state?: DoorState;
  warning?: CompartmentWarningState;
  isLongOpen?: boolean;
  lastOpenCommand?: Date | undefined;
  lastStateChangeDate?: Date | undefined;
  lastOpenErrorDate?: Date | undefined;
  openErrorCount?: number;
}

export class CompartmentRequest implements ICompartmentRequest {
  /** The locker ID */
  lockerId!: string;
  /** Compartment number */
  compartmentNumber!: number;

  constructor(data?: ICompartmentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
      this.compartmentNumber = _data["compartmentNumber"];
    }
  }

  static fromJS(data: any): CompartmentRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CompartmentRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    data["compartmentNumber"] = this.compartmentNumber;
    return data;
  }
}

export interface ICompartmentRequest {
  /** The locker ID */
  lockerId: string;
  /** Compartment number */
  compartmentNumber: number;
}

export class CompartmentStateListResponse implements ICompartmentStateListResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  compartments?: Compartment[] | undefined;

  constructor(data?: ICompartmentStateListResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      if (Array.isArray(_data["compartments"])) {
        this.compartments = [] as any;
        for (let item of _data["compartments"])
          this.compartments!.push(Compartment.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CompartmentStateListResponse {
    data = typeof data === 'object' ? data : {};
    let result = new CompartmentStateListResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    if (Array.isArray(this.compartments)) {
      data["compartments"] = [];
      for (let item of this.compartments)
        data["compartments"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICompartmentStateListResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  compartments?: Compartment[] | undefined;
}

export class CompartmentStatusResponse implements ICompartmentStatusResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  state?: DoorState;

  constructor(data?: ICompartmentStatusResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): CompartmentStatusResponse {
    data = typeof data === 'object' ? data : {};
    let result = new CompartmentStatusResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["state"] = this.state;
    return data;
  }
}

export interface ICompartmentStatusResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  state?: DoorState;
}

/** <p>Members:</p><ul></ul> */
export enum CompartmentWarningState {
  None = "None",
  Water = "Water",
}

export class CompartmentWithWorkflowRequest implements ICompartmentWithWorkflowRequest {
  /** The locker ID */
  lockerId!: string;
  /** Compartment number */
  compartmentNumber!: number;
  workflowType!: EventType;

  constructor(data?: ICompartmentWithWorkflowRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
      this.compartmentNumber = _data["compartmentNumber"];
      this.workflowType = _data["workflowType"];
    }
  }

  static fromJS(data: any): CompartmentWithWorkflowRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CompartmentWithWorkflowRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    data["compartmentNumber"] = this.compartmentNumber;
    data["workflowType"] = this.workflowType;
    return data;
  }
}

export interface ICompartmentWithWorkflowRequest {
  /** The locker ID */
  lockerId: string;
  /** Compartment number */
  compartmentNumber: number;
  workflowType: EventType;
}

/** <p>Members:</p><ul></ul> */
export enum ConnectionStatus {
  Disconnected = "Disconnected",
  Connected = "Connected",
}

/** <p>Members:</p><ul></ul> */
export enum DoorState {
  Closed = "Closed",
  Open = "Open",
  Unknown = "Unknown",
}

/** <p>Members:</p><ul></ul> */
export enum EventType {
  None = "None",
  Send = "Send",
  Pickup = "Pickup",
}

export class FanStatus implements IFanStatus {
  fanNumber?: number;
  mode?: WorkingMode;
  status?: WorkingStatus;

  constructor(data?: IFanStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fanNumber = _data["fanNumber"];
      this.mode = _data["mode"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): FanStatus {
    data = typeof data === 'object' ? data : {};
    let result = new FanStatus();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fanNumber"] = this.fanNumber;
    data["mode"] = this.mode;
    data["status"] = this.status;
    return data;
  }
}

export interface IFanStatus {
  fanNumber?: number;
  mode?: WorkingMode;
  status?: WorkingStatus;
}

export class FanStatusesResponse implements IFanStatusesResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** The list of statuses of all installed fans. */
  state?: FanStatus[] | undefined;

  constructor(data?: IFanStatusesResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      if (Array.isArray(_data["state"])) {
        this.state = [] as any;
        for (let item of _data["state"])
          this.state!.push(FanStatus.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FanStatusesResponse {
    data = typeof data === 'object' ? data : {};
    let result = new FanStatusesResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    if (Array.isArray(this.state)) {
      data["state"] = [];
      for (let item of this.state)
        data["state"].push(item.toJSON());
    }
    return data;
  }
}

export interface IFanStatusesResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** The list of statuses of all installed fans. */
  state?: FanStatus[] | undefined;
}

export class FanTemperatureLimitsRequest implements IFanTemperatureLimitsRequest {
  /** The locker ID */
  lockerId!: string;
  fanSetting?: FanTemperatureSettings;

  constructor(data?: IFanTemperatureLimitsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
      this.fanSetting = _data["fanSetting"] ? FanTemperatureSettings.fromJS(_data["fanSetting"]) : <any>undefined;
    }
  }

  static fromJS(data: any): FanTemperatureLimitsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new FanTemperatureLimitsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    data["fanSetting"] = this.fanSetting ? this.fanSetting.toJSON() : <any>undefined;
    return data;
  }
}

export interface IFanTemperatureLimitsRequest {
  /** The locker ID */
  lockerId: string;
  fanSetting?: FanTemperatureSettings;
}

export class FanTemperatureLimitsResponse implements IFanTemperatureLimitsResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** The list of temperature limits for all installed fans. */
  state?: FanTemperatureSettings[] | undefined;

  constructor(data?: IFanTemperatureLimitsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      if (Array.isArray(_data["state"])) {
        this.state = [] as any;
        for (let item of _data["state"])
          this.state!.push(FanTemperatureSettings.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FanTemperatureLimitsResponse {
    data = typeof data === 'object' ? data : {};
    let result = new FanTemperatureLimitsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    if (Array.isArray(this.state)) {
      data["state"] = [];
      for (let item of this.state)
        data["state"].push(item.toJSON());
    }
    return data;
  }
}

export interface IFanTemperatureLimitsResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** The list of temperature limits for all installed fans. */
  state?: FanTemperatureSettings[] | undefined;
}

export class FanTemperatureSettings implements IFanTemperatureSettings {
  fanNumber?: number;
  lowerLimit?: number;
  upperLimit?: number;

  constructor(data?: IFanTemperatureSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fanNumber = _data["fanNumber"];
      this.lowerLimit = _data["lowerLimit"];
      this.upperLimit = _data["upperLimit"];
    }
  }

  static fromJS(data: any): FanTemperatureSettings {
    data = typeof data === 'object' ? data : {};
    let result = new FanTemperatureSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fanNumber"] = this.fanNumber;
    data["lowerLimit"] = this.lowerLimit;
    data["upperLimit"] = this.upperLimit;
    return data;
  }
}

export interface IFanTemperatureSettings {
  fanNumber?: number;
  lowerLimit?: number;
  upperLimit?: number;
}

export class FirmwareUpdateResponse implements IFirmwareUpdateResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  state?: FirmwareUpdateStatus;
  firmwareUpdateProgress?: number | undefined;

  constructor(data?: IFirmwareUpdateResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.state = _data["state"];
      this.firmwareUpdateProgress = _data["firmwareUpdateProgress"];
    }
  }

  static fromJS(data: any): FirmwareUpdateResponse {
    data = typeof data === 'object' ? data : {};
    let result = new FirmwareUpdateResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["state"] = this.state;
    data["firmwareUpdateProgress"] = this.firmwareUpdateProgress;
    return data;
  }
}

export interface IFirmwareUpdateResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  state?: FirmwareUpdateStatus;
  firmwareUpdateProgress?: number | undefined;
}

/** <p>Members:</p><ul></ul> */
export enum FirmwareUpdateStatus {
  Successful = "Successful",
  Failed = "Failed",
  InProgress = "InProgress",
  ErrorInUpgradeFile = "ErrorInUpgradeFile",
  None = "None",
}

export class GetApiInfoResponse implements IGetApiInfoResponse {
  version?: string | undefined;
  logUrl?: string | undefined;

  constructor(data?: IGetApiInfoResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data["version"];
      this.logUrl = _data["logUrl"];
    }
  }

  static fromJS(data: any): GetApiInfoResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetApiInfoResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["version"] = this.version;
    data["logUrl"] = this.logUrl;
    return data;
  }
}

export interface IGetApiInfoResponse {
  version?: string | undefined;
  logUrl?: string | undefined;
}

export class GetConfigResponse implements IGetConfigResponse {
  clientId?: string | undefined;
  authority?: string | undefined;
  scopes?: string[] | undefined;

  constructor(data?: IGetConfigResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data["clientId"];
      this.authority = _data["authority"];
      if (Array.isArray(_data["scopes"])) {
        this.scopes = [] as any;
        for (let item of _data["scopes"])
          this.scopes!.push(item);
      }
    }
  }

  static fromJS(data: any): GetConfigResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetConfigResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["clientId"] = this.clientId;
    data["authority"] = this.authority;
    if (Array.isArray(this.scopes)) {
      data["scopes"] = [];
      for (let item of this.scopes)
        data["scopes"].push(item);
    }
    return data;
  }
}

export interface IGetConfigResponse {
  clientId?: string | undefined;
  authority?: string | undefined;
  scopes?: string[] | undefined;
}

export class GetCurrentUserResponse implements IGetCurrentUserResponse {
  name?: string | undefined;
  isAuthenticated?: boolean;
  roles?: string[] | undefined;

  constructor(data?: IGetCurrentUserResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.isAuthenticated = _data["isAuthenticated"];
      if (Array.isArray(_data["roles"])) {
        this.roles = [] as any;
        for (let item of _data["roles"])
          this.roles!.push(item);
      }
    }
  }

  static fromJS(data: any): GetCurrentUserResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetCurrentUserResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["isAuthenticated"] = this.isAuthenticated;
    if (Array.isArray(this.roles)) {
      data["roles"] = [];
      for (let item of this.roles)
        data["roles"].push(item);
    }
    return data;
  }
}

export interface IGetCurrentUserResponse {
  name?: string | undefined;
  isAuthenticated?: boolean;
  roles?: string[] | undefined;
}

export class GetOldestLogDateResponse implements IGetOldestLogDateResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** Returns the oldest date for which the locker has a log */
  oldestLogAvailable?: Date | undefined;

  constructor(data?: IGetOldestLogDateResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.oldestLogAvailable = _data["oldestLogAvailable"] ? new Date(_data["oldestLogAvailable"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): GetOldestLogDateResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetOldestLogDateResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["oldestLogAvailable"] = this.oldestLogAvailable ? this.oldestLogAvailable.toISOString() : <any>undefined;
    return data;
  }
}

export interface IGetOldestLogDateResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** Returns the oldest date for which the locker has a log */
  oldestLogAvailable?: Date | undefined;
}

export class GetProviderParametersRequest implements IGetProviderParametersRequest {
  /** The locker ID */
  lockerId!: string;
  /** The card number to get the options for (1-3 only!) */
  cardNumber?: number;

  constructor(data?: IGetProviderParametersRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
      this.cardNumber = _data["cardNumber"];
    }
  }

  static fromJS(data: any): GetProviderParametersRequest {
    data = typeof data === 'object' ? data : {};
    let result = new GetProviderParametersRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    data["cardNumber"] = this.cardNumber;
    return data;
  }
}

export interface IGetProviderParametersRequest {
  /** The locker ID */
  lockerId: string;
  /** The card number to get the options for (1-3 only!) */
  cardNumber?: number;
}

export class GetProviderParametersResponse implements IGetProviderParametersResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** The card number */
  cardNumber?: number;
  /** The name of the wireless network operator (max. 15 characters) */
  operatorName?: string | undefined;
  /** MCC (Mobile Country Code) */
  mcc?: string | undefined;
  /** MNC (Mobile Network Code) */
  mnc?: string | undefined;
  /** APN */
  apn?: string | undefined;
  /** IP protocol */
  ipProtocol?: string | undefined;

  constructor(data?: IGetProviderParametersResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.cardNumber = _data["cardNumber"];
      this.operatorName = _data["operatorName"];
      this.mcc = _data["mcc"];
      this.mnc = _data["mnc"];
      this.apn = _data["apn"];
      this.ipProtocol = _data["ipProtocol"];
    }
  }

  static fromJS(data: any): GetProviderParametersResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetProviderParametersResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["cardNumber"] = this.cardNumber;
    data["operatorName"] = this.operatorName;
    data["mcc"] = this.mcc;
    data["mnc"] = this.mnc;
    data["apn"] = this.apn;
    data["ipProtocol"] = this.ipProtocol;
    return data;
  }
}

export interface IGetProviderParametersResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** The card number */
  cardNumber?: number;
  /** The name of the wireless network operator (max. 15 characters) */
  operatorName?: string | undefined;
  /** MCC (Mobile Country Code) */
  mcc?: string | undefined;
  /** MNC (Mobile Network Code) */
  mnc?: string | undefined;
  /** APN */
  apn?: string | undefined;
  /** IP protocol */
  ipProtocol?: string | undefined;
}

export class GetUsedOfflinePinResponse implements IGetUsedOfflinePinResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  usage?: OfflinePinUsage;

  constructor(data?: IGetUsedOfflinePinResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.usage = _data["usage"] ? OfflinePinUsage.fromJS(_data["usage"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetUsedOfflinePinResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetUsedOfflinePinResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["usage"] = this.usage ? this.usage.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetUsedOfflinePinResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  usage?: OfflinePinUsage;
}

export class GetUsedOfflinePinsResponse implements IGetUsedOfflinePinsResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  usages?: OfflinePinUsage[] | undefined;

  constructor(data?: IGetUsedOfflinePinsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      if (Array.isArray(_data["usages"])) {
        this.usages = [] as any;
        for (let item of _data["usages"])
          this.usages!.push(OfflinePinUsage.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetUsedOfflinePinsResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetUsedOfflinePinsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    if (Array.isArray(this.usages)) {
      data["usages"] = [];
      for (let item of this.usages)
        data["usages"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetUsedOfflinePinsResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  usages?: OfflinePinUsage[] | undefined;
}

export class ILockerReport implements IILockerReport {
  date?: Date;
  temperature?: number;
  batteryLevel?: number;
  minBatteryLevel?: number;
  minBatteryLevelDate?: Date;
  signalStrength?: number;
  firmwareVersion?: string | undefined;
  arrayVoltage?: number | undefined;
  arrayCurrent?: number | undefined;
  loadVoltage?: number | undefined;
  loadCurrent?: number | undefined;
  batteryVoltage?: number | undefined;
  batteryCurrent?: number | undefined;
  batteryTemperature?: number | undefined;
  batteryStatus?: number;
  chargingStatus?: number;
  dischargeStatus?: number;
  errorCodes?: number[] | undefined;

  constructor(data?: IILockerReport) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
      this.temperature = _data["temperature"];
      this.batteryLevel = _data["batteryLevel"];
      this.minBatteryLevel = _data["minBatteryLevel"];
      this.minBatteryLevelDate = _data["minBatteryLevelDate"] ? new Date(_data["minBatteryLevelDate"].toString()) : <any>undefined;
      this.signalStrength = _data["signalStrength"];
      this.firmwareVersion = _data["firmwareVersion"];
      this.arrayVoltage = _data["arrayVoltage"];
      this.arrayCurrent = _data["arrayCurrent"];
      this.loadVoltage = _data["loadVoltage"];
      this.loadCurrent = _data["loadCurrent"];
      this.batteryVoltage = _data["batteryVoltage"];
      this.batteryCurrent = _data["batteryCurrent"];
      this.batteryTemperature = _data["batteryTemperature"];
      this.batteryStatus = _data["batteryStatus"];
      this.chargingStatus = _data["chargingStatus"];
      this.dischargeStatus = _data["dischargeStatus"];
      if (Array.isArray(_data["errorCodes"])) {
        this.errorCodes = [] as any;
        for (let item of _data["errorCodes"])
          this.errorCodes!.push(item);
      }
    }
  }

  static fromJS(data: any): ILockerReport {
    data = typeof data === 'object' ? data : {};
    let result = new ILockerReport();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["temperature"] = this.temperature;
    data["batteryLevel"] = this.batteryLevel;
    data["minBatteryLevel"] = this.minBatteryLevel;
    data["minBatteryLevelDate"] = this.minBatteryLevelDate ? this.minBatteryLevelDate.toISOString() : <any>undefined;
    data["signalStrength"] = this.signalStrength;
    data["firmwareVersion"] = this.firmwareVersion;
    data["arrayVoltage"] = this.arrayVoltage;
    data["arrayCurrent"] = this.arrayCurrent;
    data["loadVoltage"] = this.loadVoltage;
    data["loadCurrent"] = this.loadCurrent;
    data["batteryVoltage"] = this.batteryVoltage;
    data["batteryCurrent"] = this.batteryCurrent;
    data["batteryTemperature"] = this.batteryTemperature;
    data["batteryStatus"] = this.batteryStatus;
    data["chargingStatus"] = this.chargingStatus;
    data["dischargeStatus"] = this.dischargeStatus;
    if (Array.isArray(this.errorCodes)) {
      data["errorCodes"] = [];
      for (let item of this.errorCodes)
        data["errorCodes"].push(item);
    }
    return data;
  }
}

export interface IILockerReport {
  date?: Date;
  temperature?: number;
  batteryLevel?: number;
  minBatteryLevel?: number;
  minBatteryLevelDate?: Date;
  signalStrength?: number;
  firmwareVersion?: string | undefined;
  arrayVoltage?: number | undefined;
  arrayCurrent?: number | undefined;
  loadVoltage?: number | undefined;
  loadCurrent?: number | undefined;
  batteryVoltage?: number | undefined;
  batteryCurrent?: number | undefined;
  batteryTemperature?: number | undefined;
  batteryStatus?: number;
  chargingStatus?: number;
  dischargeStatus?: number;
  errorCodes?: number[] | undefined;
}

export class IccidResponse implements IIccidResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  iccid?: string | undefined;

  constructor(data?: IIccidResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.iccid = _data["iccid"];
    }
  }

  static fromJS(data: any): IccidResponse {
    data = typeof data === 'object' ? data : {};
    let result = new IccidResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["iccid"] = this.iccid;
    return data;
  }
}

export interface IIccidResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  iccid?: string | undefined;
}

export class ImeiResponse implements IImeiResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  imei?: string | undefined;

  constructor(data?: IImeiResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.imei = _data["imei"];
    }
  }

  static fromJS(data: any): ImeiResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ImeiResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["imei"] = this.imei;
    return data;
  }
}

export interface IImeiResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  imei?: string | undefined;
}

export class LockerDetailDto implements ILockerDetailDto {
  uuid?: string | undefined;
  state?: LockerState;
  connectionStatus?: ConnectionStatus;
  bluetoothConnectionStatus?: ConnectionStatus;
  lastConnected?: Date | undefined;
  doorCount?: number;
  doorColumns?: number[] | undefined;
  report?: ILockerReport;
  stabilityCounter?: LockerStabilityCounterDto;
  rsaKeyCreated?: Date | undefined;
  canSwitchRsaKeys?: boolean;
  compartments?: CompartmentDto[] | undefined;

  constructor(data?: ILockerDetailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uuid = _data["uuid"];
      this.state = _data["state"];
      this.connectionStatus = _data["connectionStatus"];
      this.bluetoothConnectionStatus = _data["bluetoothConnectionStatus"];
      this.lastConnected = _data["lastConnected"] ? new Date(_data["lastConnected"].toString()) : <any>undefined;
      this.doorCount = _data["doorCount"];
      if (Array.isArray(_data["doorColumns"])) {
        this.doorColumns = [] as any;
        for (let item of _data["doorColumns"])
          this.doorColumns!.push(item);
      }
      this.report = _data["report"] ? ILockerReport.fromJS(_data["report"]) : <any>undefined;
      this.stabilityCounter = _data["stabilityCounter"] ? LockerStabilityCounterDto.fromJS(_data["stabilityCounter"]) : <any>undefined;
      this.rsaKeyCreated = _data["rsaKeyCreated"] ? new Date(_data["rsaKeyCreated"].toString()) : <any>undefined;
      this.canSwitchRsaKeys = _data["canSwitchRsaKeys"];
      if (Array.isArray(_data["compartments"])) {
        this.compartments = [] as any;
        for (let item of _data["compartments"])
          this.compartments!.push(CompartmentDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): LockerDetailDto {
    data = typeof data === 'object' ? data : {};
    let result = new LockerDetailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["uuid"] = this.uuid;
    data["state"] = this.state;
    data["connectionStatus"] = this.connectionStatus;
    data["bluetoothConnectionStatus"] = this.bluetoothConnectionStatus;
    data["lastConnected"] = this.lastConnected ? this.lastConnected.toISOString() : <any>undefined;
    data["doorCount"] = this.doorCount;
    if (Array.isArray(this.doorColumns)) {
      data["doorColumns"] = [];
      for (let item of this.doorColumns)
        data["doorColumns"].push(item);
    }
    data["report"] = this.report ? this.report.toJSON() : <any>undefined;
    data["stabilityCounter"] = this.stabilityCounter ? this.stabilityCounter.toJSON() : <any>undefined;
    data["rsaKeyCreated"] = this.rsaKeyCreated ? this.rsaKeyCreated.toISOString() : <any>undefined;
    data["canSwitchRsaKeys"] = this.canSwitchRsaKeys;
    if (Array.isArray(this.compartments)) {
      data["compartments"] = [];
      for (let item of this.compartments)
        data["compartments"].push(item.toJSON());
    }
    return data;
  }
}

export interface ILockerDetailDto {
  uuid?: string | undefined;
  state?: LockerState;
  connectionStatus?: ConnectionStatus;
  bluetoothConnectionStatus?: ConnectionStatus;
  lastConnected?: Date | undefined;
  doorCount?: number;
  doorColumns?: number[] | undefined;
  report?: ILockerReport;
  stabilityCounter?: LockerStabilityCounterDto;
  rsaKeyCreated?: Date | undefined;
  canSwitchRsaKeys?: boolean;
  compartments?: CompartmentDto[] | undefined;
}

export class LockerListDto implements ILockerListDto {
  uuid?: string | undefined;
  state?: LockerState;
  connectionStatus?: ConnectionStatus;
  bluetoothConnectionStatus?: ConnectionStatus;
  lastConnected?: Date | undefined;
  doorCount?: number;
  doorColumns?: number[] | undefined;
  report?: ILockerReport;
  stabilityCounter?: LockerStabilityCounterDto;
  longOpenedDoors?: number[] | undefined;
  waterWarningDoors?: number[] | undefined;

  constructor(data?: ILockerListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uuid = _data["uuid"];
      this.state = _data["state"];
      this.connectionStatus = _data["connectionStatus"];
      this.bluetoothConnectionStatus = _data["bluetoothConnectionStatus"];
      this.lastConnected = _data["lastConnected"] ? new Date(_data["lastConnected"].toString()) : <any>undefined;
      this.doorCount = _data["doorCount"];
      if (Array.isArray(_data["doorColumns"])) {
        this.doorColumns = [] as any;
        for (let item of _data["doorColumns"])
          this.doorColumns!.push(item);
      }
      this.report = _data["report"] ? ILockerReport.fromJS(_data["report"]) : <any>undefined;
      this.stabilityCounter = _data["stabilityCounter"] ? LockerStabilityCounterDto.fromJS(_data["stabilityCounter"]) : <any>undefined;
      if (Array.isArray(_data["longOpenedDoors"])) {
        this.longOpenedDoors = [] as any;
        for (let item of _data["longOpenedDoors"])
          this.longOpenedDoors!.push(item);
      }
      if (Array.isArray(_data["waterWarningDoors"])) {
        this.waterWarningDoors = [] as any;
        for (let item of _data["waterWarningDoors"])
          this.waterWarningDoors!.push(item);
      }
    }
  }

  static fromJS(data: any): LockerListDto {
    data = typeof data === 'object' ? data : {};
    let result = new LockerListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["uuid"] = this.uuid;
    data["state"] = this.state;
    data["connectionStatus"] = this.connectionStatus;
    data["bluetoothConnectionStatus"] = this.bluetoothConnectionStatus;
    data["lastConnected"] = this.lastConnected ? this.lastConnected.toISOString() : <any>undefined;
    data["doorCount"] = this.doorCount;
    if (Array.isArray(this.doorColumns)) {
      data["doorColumns"] = [];
      for (let item of this.doorColumns)
        data["doorColumns"].push(item);
    }
    data["report"] = this.report ? this.report.toJSON() : <any>undefined;
    data["stabilityCounter"] = this.stabilityCounter ? this.stabilityCounter.toJSON() : <any>undefined;
    if (Array.isArray(this.longOpenedDoors)) {
      data["longOpenedDoors"] = [];
      for (let item of this.longOpenedDoors)
        data["longOpenedDoors"].push(item);
    }
    if (Array.isArray(this.waterWarningDoors)) {
      data["waterWarningDoors"] = [];
      for (let item of this.waterWarningDoors)
        data["waterWarningDoors"].push(item);
    }
    return data;
  }
}

export interface ILockerListDto {
  uuid?: string | undefined;
  state?: LockerState;
  connectionStatus?: ConnectionStatus;
  bluetoothConnectionStatus?: ConnectionStatus;
  lastConnected?: Date | undefined;
  doorCount?: number;
  doorColumns?: number[] | undefined;
  report?: ILockerReport;
  stabilityCounter?: LockerStabilityCounterDto;
  longOpenedDoors?: number[] | undefined;
  waterWarningDoors?: number[] | undefined;
}

export class LockerRequest implements ILockerRequest {
  /** The locker ID */
  lockerId!: string;

  constructor(data?: ILockerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
    }
  }

  static fromJS(data: any): LockerRequest {
    data = typeof data === 'object' ? data : {};
    let result = new LockerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    return data;
  }
}

export interface ILockerRequest {
  /** The locker ID */
  lockerId: string;
}

export class LockerSessionStateDto implements ILockerSessionStateDto {
  bytesPending?: number;
  bytesSending?: number;
  bytesSent?: number;
  bytesReceived?: number;
  lockerId?: string | undefined;
  sessionId?: string;
  channelType?: CommunicationChannelType;

  constructor(data?: ILockerSessionStateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bytesPending = _data["bytesPending"];
      this.bytesSending = _data["bytesSending"];
      this.bytesSent = _data["bytesSent"];
      this.bytesReceived = _data["bytesReceived"];
      this.lockerId = _data["lockerId"];
      this.sessionId = _data["sessionId"];
      this.channelType = _data["channelType"];
    }
  }

  static fromJS(data: any): LockerSessionStateDto {
    data = typeof data === 'object' ? data : {};
    let result = new LockerSessionStateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["bytesPending"] = this.bytesPending;
    data["bytesSending"] = this.bytesSending;
    data["bytesSent"] = this.bytesSent;
    data["bytesReceived"] = this.bytesReceived;
    data["lockerId"] = this.lockerId;
    data["sessionId"] = this.sessionId;
    data["channelType"] = this.channelType;
    return data;
  }
}

export interface ILockerSessionStateDto {
  bytesPending?: number;
  bytesSending?: number;
  bytesSent?: number;
  bytesReceived?: number;
  lockerId?: string | undefined;
  sessionId?: string;
  channelType?: CommunicationChannelType;
}

export class LockerSessionStateListResponse implements ILockerSessionStateListResponse {
  result?: Result;
  sessions?: LockerSessionStateDto[] | undefined;

  constructor(data?: ILockerSessionStateListResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      if (Array.isArray(_data["sessions"])) {
        this.sessions = [] as any;
        for (let item of _data["sessions"])
          this.sessions!.push(LockerSessionStateDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): LockerSessionStateListResponse {
    data = typeof data === 'object' ? data : {};
    let result = new LockerSessionStateListResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    if (Array.isArray(this.sessions)) {
      data["sessions"] = [];
      for (let item of this.sessions)
        data["sessions"].push(item.toJSON());
    }
    return data;
  }
}

export interface ILockerSessionStateListResponse {
  result?: Result;
  sessions?: LockerSessionStateDto[] | undefined;
}

export class LockerStabilityCounterDto implements ILockerStabilityCounterDto {
  date?: Date;
  numberOfConnections?: number;
  bluetoothNumberOfConnections?: number;
  offlineInSeconds?: number;
  lastFailedCommand?: Date | undefined;
  numberOfFailedCommands?: number;
  repeatedSamePinsCount?: number;
  openErrorCount?: number;

  constructor(data?: ILockerStabilityCounterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
      this.numberOfConnections = _data["numberOfConnections"];
      this.bluetoothNumberOfConnections = _data["bluetoothNumberOfConnections"];
      this.offlineInSeconds = _data["offlineInSeconds"];
      this.lastFailedCommand = _data["lastFailedCommand"] ? new Date(_data["lastFailedCommand"].toString()) : <any>undefined;
      this.numberOfFailedCommands = _data["numberOfFailedCommands"];
      this.repeatedSamePinsCount = _data["repeatedSamePinsCount"];
      this.openErrorCount = _data["openErrorCount"];
    }
  }

  static fromJS(data: any): LockerStabilityCounterDto {
    data = typeof data === 'object' ? data : {};
    let result = new LockerStabilityCounterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["numberOfConnections"] = this.numberOfConnections;
    data["bluetoothNumberOfConnections"] = this.bluetoothNumberOfConnections;
    data["offlineInSeconds"] = this.offlineInSeconds;
    data["lastFailedCommand"] = this.lastFailedCommand ? this.lastFailedCommand.toISOString() : <any>undefined;
    data["numberOfFailedCommands"] = this.numberOfFailedCommands;
    data["repeatedSamePinsCount"] = this.repeatedSamePinsCount;
    data["openErrorCount"] = this.openErrorCount;
    return data;
  }
}

export interface ILockerStabilityCounterDto {
  date?: Date;
  numberOfConnections?: number;
  bluetoothNumberOfConnections?: number;
  offlineInSeconds?: number;
  lastFailedCommand?: Date | undefined;
  numberOfFailedCommands?: number;
  repeatedSamePinsCount?: number;
  openErrorCount?: number;
}

/** <p>Members:</p><ul></ul> */
export enum LockerState {
  New = "New",
  Deactivated = "Deactivated",
  Active = "Active",
  Production = "Production",
}

export class ModuleMemoryInfo implements IModuleMemoryInfo {
  before?: number;
  after?: number;

  constructor(data?: IModuleMemoryInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.before = _data["before"];
      this.after = _data["after"];
    }
  }

  static fromJS(data: any): ModuleMemoryInfo {
    data = typeof data === 'object' ? data : {};
    let result = new ModuleMemoryInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["before"] = this.before;
    data["after"] = this.after;
    return data;
  }
}

export interface IModuleMemoryInfo {
  before?: number;
  after?: number;
}

export class OfflinePinSetting implements IOfflinePinSetting {
  compartmentNumber?: number;
  pin?: string | undefined;

  constructor(data?: IOfflinePinSetting) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.compartmentNumber = _data["compartmentNumber"];
      this.pin = _data["pin"];
    }
  }

  static fromJS(data: any): OfflinePinSetting {
    data = typeof data === 'object' ? data : {};
    let result = new OfflinePinSetting();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["compartmentNumber"] = this.compartmentNumber;
    data["pin"] = this.pin;
    return data;
  }
}

export interface IOfflinePinSetting {
  compartmentNumber?: number;
  pin?: string | undefined;
}

export class OfflinePinUsage implements IOfflinePinUsage {
  compartmentNumber?: number;
  hasOfflinePin?: boolean;
  wasOfflinePinUsed?: boolean;
  wasCompartmentOpenedWithOfflinePin?: boolean;
  pin?: string | undefined;

  constructor(data?: IOfflinePinUsage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.compartmentNumber = _data["compartmentNumber"];
      this.hasOfflinePin = _data["hasOfflinePin"];
      this.wasOfflinePinUsed = _data["wasOfflinePinUsed"];
      this.wasCompartmentOpenedWithOfflinePin = _data["wasCompartmentOpenedWithOfflinePin"];
      this.pin = _data["pin"];
    }
  }

  static fromJS(data: any): OfflinePinUsage {
    data = typeof data === 'object' ? data : {};
    let result = new OfflinePinUsage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["compartmentNumber"] = this.compartmentNumber;
    data["hasOfflinePin"] = this.hasOfflinePin;
    data["wasOfflinePinUsed"] = this.wasOfflinePinUsed;
    data["wasCompartmentOpenedWithOfflinePin"] = this.wasCompartmentOpenedWithOfflinePin;
    data["pin"] = this.pin;
    return data;
  }
}

export interface IOfflinePinUsage {
  compartmentNumber?: number;
  hasOfflinePin?: boolean;
  wasOfflinePinUsed?: boolean;
  wasCompartmentOpenedWithOfflinePin?: boolean;
  pin?: string | undefined;
}

export class OpenCompartmentResponse implements IOpenCompartmentResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  queryTimeResult?: Result;
  doorControlResult?: Result;
  doorStatusResult?: Result;
  doorState?: DoorState;

  constructor(data?: IOpenCompartmentResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.queryTimeResult = _data["queryTimeResult"];
      this.doorControlResult = _data["doorControlResult"];
      this.doorStatusResult = _data["doorStatusResult"];
      this.doorState = _data["doorState"];
    }
  }

  static fromJS(data: any): OpenCompartmentResponse {
    data = typeof data === 'object' ? data : {};
    let result = new OpenCompartmentResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["queryTimeResult"] = this.queryTimeResult;
    data["doorControlResult"] = this.doorControlResult;
    data["doorStatusResult"] = this.doorStatusResult;
    data["doorState"] = this.doorState;
    return data;
  }
}

export interface IOpenCompartmentResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  queryTimeResult?: Result;
  doorControlResult?: Result;
  doorStatusResult?: Result;
  doorState?: DoorState;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class ReadLogRequest implements IReadLogRequest {
  /** The locker ID */
  lockerId!: string;
  /** Date for which you want to read the log. NULL means today.
   The log will be sent to the same email as the status reports.
   The time is ignored. */
  date?: Date | undefined;

  constructor(data?: IReadLogRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
      this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): ReadLogRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ReadLogRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

export interface IReadLogRequest {
  /** The locker ID */
  lockerId: string;
  /** Date for which you want to read the log. NULL means today.
   The log will be sent to the same email as the status reports.
   The time is ignored. */
  date?: Date | undefined;
}

export class ReadLogResponse implements IReadLogResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** Returns true if the locker reported that it does have the log for the requested date. */
  logAvailable?: boolean;

  constructor(data?: IReadLogResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.logAvailable = _data["logAvailable"];
    }
  }

  static fromJS(data: any): ReadLogResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ReadLogResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["logAvailable"] = this.logAvailable;
    return data;
  }
}

export interface IReadLogResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  /** Returns true if the locker reported that it does have the log for the requested date. */
  logAvailable?: boolean;
}

/** <p>Members:</p><ul></ul> */
export enum Result {
  Ok = "Ok",
  Error = "Error",
  TimeOutError = "TimeOutError",
  TooManyRequests = "TooManyRequests",
  NotFound = "NotFound",
  AccessDenied = "AccessDenied",
  TimestampExpired = "TimestampExpired",
  CommandError = "CommandError",
  AesError = "AesError",
}

export class RsaKeyResponse implements IRsaKeyResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;

  constructor(data?: IRsaKeyResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): RsaKeyResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RsaKeyResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    return data;
  }
}

export interface IRsaKeyResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
}

export class SessionRequest implements ISessionRequest {
  /** The locker session ID */
  sessionId!: string;

  constructor(data?: ISessionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sessionId = _data["sessionId"];
    }
  }

  static fromJS(data: any): SessionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SessionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["sessionId"] = this.sessionId;
    return data;
  }
}

export interface ISessionRequest {
  /** The locker session ID */
  sessionId: string;
}

export class SetLcdTextRequest implements ISetLcdTextRequest {
  /** The locker ID */
  lockerId!: string;
  text!: TextForApi;
  /** Duration in ms. IF not specified then default value 5000 is used. */
  duration?: number | undefined;

  constructor(data?: ISetLcdTextRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
      this.text = _data["text"];
      this.duration = _data["duration"];
    }
  }

  static fromJS(data: any): SetLcdTextRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SetLcdTextRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    data["text"] = this.text;
    data["duration"] = this.duration;
    return data;
  }
}

export interface ISetLcdTextRequest {
  /** The locker ID */
  lockerId: string;
  text: TextForApi;
  /** Duration in ms. IF not specified then default value 5000 is used. */
  duration?: number | undefined;
}

export class SetOfflinePinResponse implements ISetOfflinePinResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  usedPins?: boolean;

  constructor(data?: ISetOfflinePinResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.usedPins = _data["usedPins"];
    }
  }

  static fromJS(data: any): SetOfflinePinResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SetOfflinePinResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["usedPins"] = this.usedPins;
    return data;
  }
}

export interface ISetOfflinePinResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  usedPins?: boolean;
}

export class SetProviderParametersRequest implements ISetProviderParametersRequest {
  /** The locker ID */
  lockerId!: string;
  /** The card number to set the options for (1-3 only!) */
  cardNumber?: number;
  /** The name of the wireless network operator (max. 15 characters) */
  operatorName?: string | undefined;
  /** MCC (Mobile Country Code, 3 characters) */
  mcc?: string | undefined;
  /** MNC (Mobile Network Code, 2 characters) */
  mnc?: string | undefined;
  /** APN (max. 31 characters) */
  apn?: string | undefined;
  /** IP protocol (max 9 characters) */
  ipProtocol?: string | undefined;

  constructor(data?: ISetProviderParametersRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
      this.cardNumber = _data["cardNumber"];
      this.operatorName = _data["operatorName"];
      this.mcc = _data["mcc"];
      this.mnc = _data["mnc"];
      this.apn = _data["apn"];
      this.ipProtocol = _data["ipProtocol"];
    }
  }

  static fromJS(data: any): SetProviderParametersRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SetProviderParametersRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    data["cardNumber"] = this.cardNumber;
    data["operatorName"] = this.operatorName;
    data["mcc"] = this.mcc;
    data["mnc"] = this.mnc;
    data["apn"] = this.apn;
    data["ipProtocol"] = this.ipProtocol;
    return data;
  }
}

export interface ISetProviderParametersRequest {
  /** The locker ID */
  lockerId: string;
  /** The card number to set the options for (1-3 only!) */
  cardNumber?: number;
  /** The name of the wireless network operator (max. 15 characters) */
  operatorName?: string | undefined;
  /** MCC (Mobile Country Code, 3 characters) */
  mcc?: string | undefined;
  /** MNC (Mobile Network Code, 2 characters) */
  mnc?: string | undefined;
  /** APN (max. 31 characters) */
  apn?: string | undefined;
  /** IP protocol (max 9 characters) */
  ipProtocol?: string | undefined;
}

export class SimpleResponse implements ISimpleResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;

  constructor(data?: ISimpleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): SimpleResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SimpleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    return data;
  }
}

export interface ISimpleResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
}

export class SleepModeParametersRequest implements ISleepModeParametersRequest {
  /** The locker ID */
  lockerId!: string;
  /** The timeout in seconds (up to 255) */
  timeout!: number;
  eraseFirstLine?: boolean;
  eraseSecondLine?: boolean;
  turnOffLight?: boolean;

  constructor(data?: ISleepModeParametersRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
      this.timeout = _data["timeout"];
      this.eraseFirstLine = _data["eraseFirstLine"];
      this.eraseSecondLine = _data["eraseSecondLine"];
      this.turnOffLight = _data["turnOffLight"];
    }
  }

  static fromJS(data: any): SleepModeParametersRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SleepModeParametersRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    data["timeout"] = this.timeout;
    data["eraseFirstLine"] = this.eraseFirstLine;
    data["eraseSecondLine"] = this.eraseSecondLine;
    data["turnOffLight"] = this.turnOffLight;
    return data;
  }
}

export interface ISleepModeParametersRequest {
  /** The locker ID */
  lockerId: string;
  /** The timeout in seconds (up to 255) */
  timeout: number;
  eraseFirstLine?: boolean;
  eraseSecondLine?: boolean;
  turnOffLight?: boolean;
}

export class SleepModeParametersResponse implements ISleepModeParametersResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  timeout?: number;
  eraseFirstLine?: boolean;
  eraseSecondLine?: boolean;
  turnOffLight?: boolean;

  constructor(data?: ISleepModeParametersResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.timeout = _data["timeout"];
      this.eraseFirstLine = _data["eraseFirstLine"];
      this.eraseSecondLine = _data["eraseSecondLine"];
      this.turnOffLight = _data["turnOffLight"];
    }
  }

  static fromJS(data: any): SleepModeParametersResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SleepModeParametersResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["timeout"] = this.timeout;
    data["eraseFirstLine"] = this.eraseFirstLine;
    data["eraseSecondLine"] = this.eraseSecondLine;
    data["turnOffLight"] = this.turnOffLight;
    return data;
  }
}

export interface ISleepModeParametersResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  timeout?: number;
  eraseFirstLine?: boolean;
  eraseSecondLine?: boolean;
  turnOffLight?: boolean;
}

/** <p>Members:</p><ul></ul> */
export enum TextForApi {
  ClearAll = "ClearAll",
  ClearFirstLine = "ClearFirstLine",
  ClearSecondLine = "ClearSecondLine",
  Error = "Error",
  WrongCodeOrLocation = "WrongCodeOrLocation",
  WrongParcelId = "WrongParcelId",
  NoReturnContactEshop = "NoReturnContactEshop",
  FullLocker = "FullLocker",
  NotWorking = "NotWorking",
  ParcelAccepted = "ParcelAccepted",
  PendingPayment = "PendingPayment",
  Custom1 = "Custom1",
  Custom2 = "Custom2",
  Custom3 = "Custom3",
  Custom4 = "Custom4",
  Custom5 = "Custom5",
}

export class WirelessParametersRequest implements IWirelessParametersRequest {
  /** The locker ID */
  lockerId!: string;
  /** The heart beat interval in seconds */
  heartbeatInterval?: number;
  /** The wireless retry interval in seconds (for attempts to reconnect after losing connection) */
  retryInterval?: number;

  constructor(data?: IWirelessParametersRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lockerId = _data["lockerId"];
      this.heartbeatInterval = _data["heartbeatInterval"];
      this.retryInterval = _data["retryInterval"];
    }
  }

  static fromJS(data: any): WirelessParametersRequest {
    data = typeof data === 'object' ? data : {};
    let result = new WirelessParametersRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lockerId"] = this.lockerId;
    data["heartbeatInterval"] = this.heartbeatInterval;
    data["retryInterval"] = this.retryInterval;
    return data;
  }
}

export interface IWirelessParametersRequest {
  /** The locker ID */
  lockerId: string;
  /** The heart beat interval in seconds */
  heartbeatInterval?: number;
  /** The wireless retry interval in seconds (for attempts to reconnect after losing connection) */
  retryInterval?: number;
}

export class WirelessParametersResponse implements IWirelessParametersResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  heartbeatInterval?: number;
  retryInterval?: number;

  constructor(data?: IWirelessParametersResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : <any>undefined;
      this.responseSent = _data["responseSent"] ? new Date(_data["responseSent"].toString()) : <any>undefined;
      this.heartbeatInterval = _data["heartbeatInterval"];
      this.retryInterval = _data["retryInterval"];
    }
  }

  static fromJS(data: any): WirelessParametersResponse {
    data = typeof data === 'object' ? data : {};
    let result = new WirelessParametersResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : <any>undefined;
    data["responseSent"] = this.responseSent ? this.responseSent.toISOString() : <any>undefined;
    data["heartbeatInterval"] = this.heartbeatInterval;
    data["retryInterval"] = this.retryInterval;
    return data;
  }
}

export interface IWirelessParametersResponse {
  result?: Result;
  /** Date and time in UTC */
  requestReceived?: Date;
  /** Date and time in UTC */
  responseSent?: Date;
  heartbeatInterval?: number;
  retryInterval?: number;
}

/** <p>Members:</p><ul></ul> */
export enum WorkingMode {
  Manual = "Manual",
  Automatic = "Automatic",
}

/** <p>Members:</p><ul></ul> */
export enum WorkingStatus {
  Off = "Off",
  On = "On",
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
  if (result !== null && result !== undefined)
    throw result;
  else
    throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
